import { Html, html, View } from 'rune-ts';
import { MPS_ADDRESS_LANG } from '@services/MarppleShop/shared/constant';
import klass from './BusinessInformationView.module.scss';
import { DropdownView } from '@services/MarppleShop/renderApp/components/cells/Footer/views/DropdownView.ts';
import { font } from '@services/MarppleShop/shared/typography';

interface Props {
  is_mobile: boolean;
}

export class BusinessInformationView extends View<Props> {
  constructor(props: Props) {
    super(props);
  }

  private is_info_btn_opened = false;

  private readonly texts = {
    customer_center_number: ET('mps2::footer::customer_center_number'),
    company_name: T('mshop::Footer::CompanyName'),
    ceo: T('mshop::Footer::CEO'),
    ceo_name: T('mshop::Footer::CeoName'),
    company_registration_info: T('mshop::Footer::CompanyRegistrationInfo'),
    company_registration_number: T('mshop::Footer::CompanyRegistrationNumber'),
    address_info: MPS_ADDRESS_LANG[ET.lang],
    privacy_charge: ET('mps2::footer::privacy_charge'),
    privacy_charge_name: ET('mps2::footer::privacy_charge_name'),

    business_alliance_cs: T('mshop::Footer::business_alliance_cs'),
    business_alliance_email: 'biz@marppleshop.com',

    inicis_info: ET('mps2::footer::inicis_info'),
    inicis_button: ET('mps2::footer::inicis_button'),
    notice: ET('mps2::footer::notice'),
    business_info: ET('mps2::footer::business_info'),
  };

  override template() {
    return html`<div class="${klass.business_info_container}">
      ${new DropdownView({
        title: this.data.is_mobile ? this.texts.business_info : '',
        title_class: font('14_bold_px'),
        contentView: this.getDropdownContent(),
        defaultOpen: !this.data.is_mobile,
        showArrow: this.data.is_mobile,
      })}
    </div>`;
  }

  getDropdownContent(): Html {
    const font_klass = font('12_medium_px');
    return html`
      <div class="${klass.content_wrap} ${font('12_medium_px')}">
        <p class="${klass.info_first_row}">
          <span class="${font_klass}">${this.texts.company_name}</span>
          <span class="${klass.info_splitter}"></span>
          <span class="${font_klass}">${this.texts.ceo} ${this.texts.ceo_name}</span>
          <span class="${klass.info_splitter}"></span>
          <span class="${font_klass}"
            >${this.texts.company_registration_info} ${this.texts.company_registration_number}</span
          >
          <span class="${klass.info_splitter}"></span>
          ${T.lang === 'kr'
            ? html`<span class="${font_klass}">통신판매업신고번호 2021-서울금천-1710</span>
                <span class="${klass.info_splitter}"></span>`
            : ''}
          <span class="${font_klass}">${this.texts.address_info}</span>
          <span class="${klass.info_splitter}"></span>
          <span class="${font_klass}">${this.texts.privacy_charge} ${this.texts.privacy_charge_name}</span>
        </p>
        <p class="${klass.inicis_info} ${font_klass}">
          ${this.texts.inicis_info}
          <a
            href="https://mark.inicis.com/mark/escrow_popup_v3.php?mid=MOImarpple"
            class="${klass.inicis_button}"
          >
            ${this.texts.inicis_button}</a
          >
        </p>
      </div>
    `;
  }

  protected override onRender(): void {
    super.onRender();

    this.delegate('click', `.${klass.info_open_btn}`, (e) => {
      this.is_info_btn_opened = !this.is_info_btn_opened;
      const container_el = (e.currentTarget as HTMLElement)?.closest(`.${klass.info_container}`);
      if (!container_el) return;

      container_el.classList.toggle(klass.is_opened);
    });
  }
}
